import Model from 'ln/model/Model';
import { Resolvable } from 'ln/components/Resolve';
import { suspendData, updateSuspendData } from '../../ScormSingleton';

import { Module } from '../module';
import { Asset } from '../../Asset';

export interface ChapterElement extends Resolvable{
    chapter:Chapter
}

export class Chapter extends Model implements Resolvable {

    public completed:boolean;
    public hideCloseButton:boolean;
    public readonly elements:ChapterElement[];
    public readonly image:Asset;
    public module:Module;
    public readonly summary:string;
    public readonly tags:string[];
    public readonly title:string;

    constructor(json: object) {
        super({
            completed: false,
            hideCloseButton: false,
            elements:[],
            image: null,
            summary: '',
            tags:[],
            title: '',
            ...json
        });

        // inject chapter into elements
        this.elements.forEach( ( element ) => {
            element.chapter = this;
        });

        if( suspendData.data.chapters[this.get<string>( 'id' )] ) this.completed = suspendData.data.chapters[this.get<string>( 'id' )];
    }

    public getViewName(): string {
        return 'Chapter';
    }

    public toggleCompleted(): void {
        this.completed = !this.completed;
        suspendData.data.chapters[this.get<string>( 'id')] = this.completed;

        updateSuspendData();
    }

    private isNotLastChapter(){
        return !(this.module.chapters.indexOf( this ) == this.module.chapters.length - 1);
    }

    private nextChapter(){
        let currentIndex = this.module.chapters.indexOf( this );
        if( currentIndex < this.module.chapters.length - 1 ) this.module.openChapter( this.module.chapters[ currentIndex + 1 ] );
    }

    private closeChapter(){
        this.module.closeChapter();
    }
}
